/**
 * @author vishwadeep.kapoor
 * @Date: 2019-05-07 14:42:20
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-05-07 15:40:49
 */

import { fromJS } from 'immutable';
import {
  DEFAULT_ACTION,
  FETCH_GIFTCARDDETAILS_SUCCESS,
  SET_GIFTCARD_CONTACT,
} from './constants';

const initialState = fromJS({ isLoading: false, giftCardDeatils: {}, giftCardContact: { status: false } });

function giftCardProductReducer(state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case DEFAULT_ACTION:
      return state.set('isLoading', payload);
    case FETCH_GIFTCARDDETAILS_SUCCESS:
      return state
        .set('giftCardDeatils', fromJS(action.payload));
    case SET_GIFTCARD_CONTACT:
      return state
        .set('giftCardContact', fromJS(payload))
        .set('isLoading', false);
    default:
      return state;
  }
}

export default giftCardProductReducer;



// WEBPACK FOOTER //
// client/containers/GiftCardProduct/reducer.js